import { ExcavationSite, PredictionResult } from '../types';

const API_BASE_URL = '/api';

const fetchAPI = async <T>(endpoint: string, options?: RequestInit): Promise<T> => {
  try {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      ...options,
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || 'API hatası');
    return data;
  } catch (error) {
    if (error instanceof TypeError && error.message === 'Failed to fetch') {
      throw new Error('Sunucuya bağlanılamıyor.');
    }
    throw error;
  }
};

export const getSites = async (params?: { period?: string; location?: string; search?: string; limit?: number; offset?: number }) => {
  const queryParams = new URLSearchParams();
  if (params?.period) queryParams.append('period', params.period);
  if (params?.location) queryParams.append('location', params.location);
  if (params?.search) queryParams.append('search', params.search);
  if (params?.limit) queryParams.append('limit', params.limit.toString());
  if (params?.offset) queryParams.append('offset', params.offset.toString());
  const query = queryParams.toString();
  const result = await fetchAPI<{ success: boolean; data: ExcavationSite[]; meta: any }>(`/sites${query ? `?${query}` : ''}`);
  return { data: result.data, meta: result.meta };
};

export const getPeriods = async () => {
  const result = await fetchAPI<{ success: boolean; data: any[] }>('/periods');
  return result.data;
};

export const getLocations = async () => {
  const result = await fetchAPI<{ success: boolean; data: any[] }>('/locations');
  return result.data;
};

export const getStats = async () => {
  const result = await fetchAPI<{ success: boolean; data: any }>('/stats');
  return result.data;
};

export const analyzeExcavationData = async (sites?: ExcavationSite[]): Promise<PredictionResult> => {
  const result = await fetchAPI<{ success: boolean; data: PredictionResult }>('/analyze', {
    method: 'POST',
    body: JSON.stringify({ sites }),
  });
  return result.data;
};

export const askQuestion = async (question: string) => {
  const result = await fetchAPI<{ success: boolean; data: { answer: string; model: string } }>('/ask', {
    method: 'POST',
    body: JSON.stringify({ question }),
  });
  return result.data;
};

export const checkHealth = async () => {
  return await fetchAPI<any>('/health');
};
